<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useLocoI18n } from 'custom/composables/useLocoI18n';
import ScheduleMessageDialog from './ScheduleMessageDialog.vue';

// Next to the reply box's send button: schedules the current draft instead of sending it
const props = defineProps({
  conversationId: { type: Number, required: true },
  message: { type: String, default: '' },
  isNote: { type: Boolean, default: false },
});

const { t } = useLocoI18n();
const dialogRef = ref(null);

const openDialog = () => {
  dialogRef.value.open({ content: props.message, isPrivate: props.isNote });
};
</script>

<template>
  <Button
    v-tooltip.top="t('LOCO.SCHEDULED.TITLE')"
    type="button"
    icon="i-lucide-clock"
    sm
    faded
    :color="isNote ? 'amber' : 'blue'"
    class="flex-shrink-0 me-2"
    @click="openDialog"
  />
  <ScheduleMessageDialog ref="dialogRef" :conversation-id="conversationId" />
</template>
